import React, { Component, Fragment } from 'react';
import {
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import FleetService from '../../../services/FleetService';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';

class LeftPan extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      controls: props.controls,
      fleetData: props.fleetData,
      temp_id: props.temp_id
    };
  }

  deleteFleet = async (fleetId, type) => {
    const { fleetData, controls } = this.state;
    if (controls.fleetId.value === fleetId) {
      return; // the entry is in edit mode... hence return
    }
    let { isLoading } = this.state;
    try {

      _.forEach(fleetData, (d) => {
        if (d.type === type) {
          _.remove(d.data, { fleet_id: fleetId });
        }
      });

      let totalTyre = 0;
      _.forEach(fleetData, (fleet) => {
        if ((fleet.type || '').toLowerCase() === type.toLowerCase()) {
          _.forEach(fleet.data, (d) => {
            if (d && d.number_of_tyres_vehicle_count && Object.keys(d.number_of_tyres_vehicle_count).length) {
              totalTyre += _.sum(Object.values(d.number_of_tyres_vehicle_count || {}));
            }
          });
        }
      });
      isLoading = true;

      this.setState({ isLoading });
      await FleetService.deleteFleet({ fleetId, totalTyre }, this.state.temp_id ? this.state.temp_id : null);
      isLoading = false;
      this.setState({ isLoading, fleetData });
    } catch (error) {
      isLoading = false;
      this.setState({ isLoading });
      console.log(error);
    }
  }

  editFleet = (fleet, index) => {
    const { controls } = this.state;
    controls.vehicleType.value = {
      vehicle_type_id: fleet.vehicle_type_id,
      name: fleet.type_name
    };

    controls.vehicleBrand.value = {
      brand_id: fleet.vehicle_type_brand_id,
      name: fleet.brand_name
    };

    controls.fleetId.value = fleet.fleet_id;

    controls.fourWheeler.value = fleet.number_of_tyres_vehicle_count['4_wheeler'] || '';
    controls.sixWheeler.value = fleet.number_of_tyres_vehicle_count['6_wheeler'] || '';
    // controls.eightWheeler.value = fleet.number_of_tyres_vehicle_count['8_wheeler'] || '';
    controls.tenWheeler.value = fleet.number_of_tyres_vehicle_count['10_wheeler'] || '';
    controls.twelveWheeler.value = fleet.number_of_tyres_vehicle_count['12_wheeler'] || '';
    controls.fourteenWheeler.value = fleet.number_of_tyres_vehicle_count['14_wheeler'] || '';
    controls.sixteenWheeler.value = fleet.number_of_tyres_vehicle_count['16_wheeler'] || '';
    controls.eighteenWheeler.value = fleet.number_of_tyres_vehicle_count['18_wheeler'] || '';
    controls.twentyTwoWheeler.value = fleet.number_of_tyres_vehicle_count['22_wheeler'] || '';
    controls.twentyEightWheeler.value = fleet.number_of_tyres_vehicle_count['28_wheeler'] || '';

    this.setState({ controls });
    this.props.updateState({ visibleArea: 'vehicleCount', controls, isEdit: true, editIndex: index, updatedCount: fleet.number_of_tyres_vehicle_count });
  }


  updateState() {
    this.setState({ fleetData: this.props.fleetData });
  }

  render() {
    const { currentFleetData } = this.props;
    const { fleetData, isLoading, controls } = this.state;
    return (
      <>
        {isLoading && <CustomSpinner />}
        {
          ((fleetData && fleetData[0] && !(fleetData[0].data || []).length) && (fleetData && fleetData[1] && !(fleetData[1].data || []).length)) &&
          <Card>
            <CardBody>
              <div className="initial-text all-text-style">
                Start building your fleet by selecting the type of vehicle you own!
              </div>
            </CardBody>
          </Card>
        }
        {
          (fleetData || []).map((fleet, i) => (
            <>
              {
                fleet.data.length > 0 && <Card key={fleet.type}>
                  <CardBody style={{ padding: '0.6rem' }}>
                    {
                      <Fragment>
                        <div>
                          <img src={fleet.type_image_url} alt={fleet.type} className="fleet-reg-header-image" />
                          <span className="fleet-reg-list-title">{fleet.type}</span>
                        </div>
                        <hr className="hr" />


                        <div className="margin-top-15">

                          {
                            (fleet.type || '').toLowerCase() === 'truck' &&
                            <>
                              {
                                (fleet.data || []).map((item, index) => (
                                  item.vehicle_type_brand_id && <Fragment key={item.brand_name}>
                                    <Row>
                                      <Col xs="2" />
                                      <Col xs="4" className="fleet-reg-title">
                                        Make
                                      </Col>
                                      <Col xs="4" className="fleet-reg-title">
                                        Count
                                      </Col>
                                      <Col xs="2" className="fleet-reg-title">
                                        {
                                          item.fleet_id &&
                                          <div>
                                            <FontAwesomeIcon onClick={(e) => this.deleteFleet(item.fleet_id, item.type_name)} icon={faTrash} title="Delete" style={controls.fleetId.value === item.fleet_id ? { color: '#fdbb1f', opacity: '0.6' } : { color: '#fdbb1f', cursor: 'pointer' }} />
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <FontAwesomeIcon disabled={controls.fleetId.value === item.fleet_id} onClick={(e) => this.editFleet(item, index)} icon={faEdit} title="Edit" style={{ color: '#fdbb1f', cursor: 'pointer' }} />
                                          </div>
                                        }
                                      </Col>
                                    </Row>

                                    <Row className="margin-top-15">
                                      <Col xs="2">
                                        <img src={item.brand_image_url || ((item.brand_name || '').toLowerCase() === 'other' ? '/images/no-image-available.jpg' : '')} alt={item.brand_name} className="fleet-reg-image" />
                                      </Col>
                                      <Col xs="4" title={item.brand_name} className="make-data text-overflow-dots">
                                        {item.brand_name}
                                      </Col>
                                      <Col xs="6">
                                        {
                                          item.number_of_tyres_vehicle_count['6_wheeler'] > 0 && <div>
                                            <span className="count-title">6 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['6_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['10_wheeler'] > 0 && <div>
                                            <span className="count-title">10 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['10_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['12_wheeler'] > 0 && <div>
                                            <span className="count-title">12 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['12_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['14_wheeler'] > 0 && <div>
                                            <span className="count-title">14 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['14_wheeler']}</span>
                                          </div>
                                        }
                                        {
                                          item.number_of_tyres_vehicle_count['16_wheeler'] > 0 && <div>
                                            <span className="count-title">16 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['16_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['18_wheeler'] > 0 && <div>
                                            <span className="count-title">18 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['18_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['22_wheeler'] > 0 && <div>
                                            <span className="count-title">22 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['22_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['28_wheeler'] > 0 && <div>
                                            <span className="count-title">28 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['28_wheeler']}</span>
                                          </div>
                                        }
                                      </Col>
                                    </Row>
                                    {
                                      fleet.data.length !== index + 1 ?
                                        <hr className="hr" style={{ marginTop: '15px', marginBottom: '15px' }} />
                                        : ''
                                    }
                                  </Fragment>
                                ))
                              }

                              {
                                (currentFleetData.type_name || '').toLowerCase() === 'truck' && currentFleetData.vehicle_type_brand_id &&
                                <>
                                  <hr />
                                  <Row className="margin-top-15">
                                    <Col xs="2">
                                      <img src={currentFleetData.brand_image_url} alt={currentFleetData.brand_name} className="fleet-reg-image" />
                                    </Col>
                                    <Col xs="4" title={currentFleetData.brand_name} className="make-data text-overflow-dots">
                                      {currentFleetData.brand_name}
                                    </Col>
                                    <Col xs="6">
                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['6_wheeler'] > 0 && <div>
                                          <span className="count-title">6 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['6_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['10_wheeler'] > 0 && <div>
                                          <span className="count-title">10 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['10_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['12_wheeler'] > 0 && <div>
                                          <span className="count-title">12 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['12_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['14_wheeler'] > 0 && <div>
                                          <span className="count-title">14 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['14_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['16_wheeler'] > 0 && <div>
                                          <span className="count-title">16 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['16_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['18_wheeler'] > 0 && <div>
                                          <span className="count-title">18 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['18_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['22_wheeler'] > 0 && <div>
                                          <span className="count-title">22 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['22_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['28_wheeler'] > 0 && <div>
                                          <span className="count-title">28 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['28_wheeler']}</span>
                                        </div>
                                      }
                                    </Col>
                                  </Row>
                                </>
                              }
                            </>
                          }

                          {
                            (fleet.type || '').toLowerCase() === 'bus' &&
                            <>
                              {
                                (fleet.data || []).map((item, index) => (
                                  item.vehicle_type_brand_id &&
                                  <>
                                    <Row>
                                      <Col xs="2" />
                                      <Col xs="4" className="fleet-reg-title">
                                        Make
                                      </Col>
                                      <Col xs="4" className="fleet-reg-title">
                                        Count
                                      </Col>
                                      <Col xs="2" className="fleet-reg-title">

                                        {
                                          item.fleet_id &&
                                          <div>
                                            <FontAwesomeIcon onClick={(e) => this.deleteFleet(item.fleet_id, item.type_name)} icon={faTrash} title="Delete" style={{ color: '#fdbb1f', cursor: 'pointer' }} />
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <FontAwesomeIcon onClick={(e) => this.editFleet(item, index)} icon={faEdit} title="Edit" style={{ color: '#fdbb1f', cursor: 'pointer' }} />
                                          </div>
                                        }

                                      </Col>
                                    </Row>
                                    <Row className="margin-top-15" key={item.brand_name}>
                                      <Col xs="2">
                                        <img src={item.brand_image_url || ((item.brand_name || '').toLowerCase() === 'other' ? '/images/no-image-available.jpg' : '')} alt={item.brand_name} className="fleet-reg-image" />
                                      </Col>
                                      <Col xs="4" title={item.brand_name} className="make-data text-overflow-dots">
                                        {item.brand_name}
                                      </Col>
                                      <Col xs="6">
                                        {
                                          item.number_of_tyres_vehicle_count['4_wheeler'] > 0 && <div>
                                            <span className="count-title">4 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['4_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['6_wheeler'] > 0 && <div>
                                            <span className="count-title">6 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['6_wheeler']}</span>
                                          </div>
                                        }

                                        {
                                          item.number_of_tyres_vehicle_count['8_wheeler'] > 0 && <div>
                                            <span className="count-title">8 Wheeler -</span>
                                            <span>{item.number_of_tyres_vehicle_count['8_wheeler']}</span>
                                          </div>
                                        }
                                      </Col>
                                    </Row>
                                    {
                                      fleet.data.length !== index + 1 ?
                                        <hr className="hr" style={{ marginTop: '15px', marginBottom: '15px' }} />
                                        : ''
                                    }
                                  </>
                                ))
                              }

                              {
                                (currentFleetData.type_name || '').toLowerCase() === 'bus' && currentFleetData.vehicle_type_brand_id &&
                                <>
                                  <hr />
                                  <Row className="margin-top-15">
                                    <Col xs="2">
                                      <img src={currentFleetData.brand_image_url} alt={currentFleetData.brand_name} className="fleet-reg-image" />
                                    </Col>
                                    <Col xs="4" title={currentFleetData.brand_name} className="make-data text-overflow-dots">
                                      {currentFleetData.brand_name}
                                    </Col>
                                    <Col xs="6">
                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['4_wheeler'] > 0 && <div>
                                          <span className="count-title">4 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['4_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['6_wheeler'] > 0 && <div>
                                          <span className="count-title">6 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['6_wheeler']}</span>
                                        </div>
                                      }

                                      {
                                        currentFleetData.number_of_tyres_vehicle_count['8_wheeler'] > 0 && <div>
                                          <span className="count-title">8 Wheeler -</span>
                                          <span>{currentFleetData.number_of_tyres_vehicle_count['8_wheeler']}</span>
                                        </div>
                                      }
                                    </Col>
                                  </Row>
                                </>
                              }
                            </>
                          }

                        </div>
                      </Fragment>
                    }
                  </CardBody>
                </Card>}
              <br />
            </>
          ))
        }
      </>
    );
  }
}

export default LeftPan;